/*---------------------------------------------------------
	Define mixins here
------------------------------------------------------------*/

var mixins = [

	
	/*---------------------------------
		Mixin for handling clearing
	----------------------------------*/

	{
		mixin: require('./mixins/clear.js'),
	},

	/*---------------------------------
		Mixin for handling save promt
	----------------------------------*/

	{
		mixin: require('./mixins/savePromt.js'),
	},

	/*---------------------------------
		Mixin for handling error promt
	----------------------------------*/

	{
		mixin: require('./mixins/error.js'),
	},

	/*---------------------------------
		Mixin for handling encodings
	----------------------------------*/

	{
		mixin: require('./mixins/encoding.js'),
	},

	/*---------------------------------
		Mixin for checks
	----------------------------------*/

	{
		mixin: require('./mixins/checks.js'),
	},

	/*---------------------------------
		Mixin for pickers
	----------------------------------*/

	{
		mixin: require('./mixins/pickers.js'),
	},


	/*---------------------------------
		Mixin for settings
	----------------------------------*/

	{
		mixin: require('./mixins/settings.js'),
	},

	/*---------------------------------
		Mixin for saving articles
	----------------------------------*/

	{
		mixin: require('./mixins/rememberArticles.js'),
	},

	/*---------------------------------
		Images
	----------------------------------*/

	{
		mixin: require('./mixins/images.js'),
	},

	/*---------------------------------
		Filter
	----------------------------------*/

	{
		mixin: require('./mixins/filter.js'),
	},

	/*---------------------------------
		Mixin for miscs
	----------------------------------*/

	{
		mixin: require('./mixins/savedData.js'),
	}, 

	{
		mixin: require('./mixins/createImage.js'),
	}, 

	{
		mixin: require('./mixins/events.js'),
	}, 

	/*---------------------------------
		Checkout
	----------------------------------*/

	{
		mixin: require('./mixins/checkout.js'),
	},
	

]

/*---------------------------------------------------------*/


// Build modules export
var out = [];
for (var i in mixins){

	out.push(mixins[i].mixin)
}

// Routes
module.exports = out; 


// WEBPACK FOOTER //
// ./client/mixins.js